var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H3a3 3 0 00-3 3v16l.006.114c.087.814 1.099 1.196 1.701.593L5.414 16H17a3 3 0 003-3V3a3 3 0 00-3-3zM3 2h14a1 1 0 011 1v10a1 1 0 01-1 1H5l-.131.009a1 1 0 00-.576.284L2 16.585V3a1 1 0 011-1z",
    fill: "#596F85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.7ad4b2f0fe7932e8c4429eb54eb8bae1.svg";
export { ForwardRef as ReactComponent };